import AlertTitle from '@mui/material/AlertTitle';

import { InfoAlert } from '../InfoAlert';
import { MessageList } from '../MessageList';

import { useContentEditGate } from './hooks/useContentEditGate.hook';

// Why the content of the document is read-only, above it.
export const ContentLockNotice = () => {
  const { isAllowed, reasons } = useContentEditGate();

  return isAllowed || !reasons.length ? null : (
    <InfoAlert sx={{ mt: 2 }}>
      <AlertTitle>Document en lecture seule</AlertTitle>
      <MessageList messages={reasons} />
    </InfoAlert>
  );
};
